import { mapGeoPoint } from '@/entities/order/lib/mapGeoPoint'

export function parseCourierLocationEvent(payload) {
  if (!payload || typeof payload !== 'object') {
    return null
  }

  const orderId = payload.order_id != null ? String(payload.order_id) : ''
  const courierId = payload.courier_id != null ? String(payload.courier_id) : null
  const location = mapGeoPoint({ lat: payload.lat, lng: payload.lng })
  const recordedAt = payload.recorded_at ?? null

  if (!orderId || !location) {
    return null
  }

  return { orderId, courierId, location, recordedAt }
}
